import { differenceInDays, format } from "date-fns";

const variables = (item: any): { [key: string]: string } => ({
  internetSaleTo: item.saleTo ? format(item.saleTo, "dd.MM.yyyy") : "",
  ticketsLeft: item.capacity ? (item.capacity - item.reserved).toString() : "",
  daysToLeft: item.saleTo ? differenceInDays(item.saleTo, new Date()).toString() : "",
});

export const replaceVariablesInString = (string: string, item: any): string => {
  if (typeof string !== "string") {
    return "";
  }

  let result = string;
  const vars = variables(item);

  if (Object.keys(vars).length === 0) {
    return "";
  }

  Object.keys(vars).forEach((variable) => {
    if (typeof vars[variable] === "string") {
      result = result.replace(new RegExp(`{{${variable}}}`, "g"), vars[variable]);
    }
  });

  return result;
};
